import { IconDefinition } from 'fontawesome/free-solid-svg-icons'

export const MOST_IMPROVED_TEAM_MEMBER = 'most_improved_team_member'
export const MOST_PROMOTER_RESPONSES = 'most_promoter_responses'
export const MOST_POSITIVE_LONG_FORM_RESPONSES =
    'most_positive_long_form_responses'
export type PraiseActionGenerator =
    | typeof MOST_IMPROVED_TEAM_MEMBER
    | typeof MOST_PROMOTER_RESPONSES
    | typeof MOST_POSITIVE_LONG_FORM_RESPONSES

export const SEND_METHOD_EMAIL = 'email_praise'
export const SEND_METHOD_INTERNAL_NOTE = 'internal_note'
export const SEND_METHOD_SLACK = 'slack'
export const SEND_METHOD_TEAMS = 'microsoft_teams'
export type PraiseActionSendMethodKey =
    | typeof SEND_METHOD_EMAIL
    | typeof SEND_METHOD_INTERNAL_NOTE
    | typeof SEND_METHOD_SLACK
    | typeof SEND_METHOD_TEAMS

export type RecommendedAction = PraiseAction | RespondAction

export const RECIPIENT_TYPE_STAFF = 'frontline_staff'
export const RECIPIENT_TYPE_LOCATION = 'location'
export type RecipientType =
    | typeof RECIPIENT_TYPE_STAFF
    | typeof RECIPIENT_TYPE_LOCATION

interface BaseAction {
    type: 'praise' | 'respond'
    category: 'promoter' | 'detractor'
    message: string // HTML string
    slug?: string // ID for backend
}

export interface PraiseAction extends BaseAction {
    type: 'praise'
    generator: PraiseActionGenerator
    userId: number
    userName: string
    userEmail: string
    responses: ActionResponse[]
    slug: string // ID for backend
    recipient?: string
    staffOnly?: boolean
    recipientType?: RecipientType
    location?: string
}

export interface RespondAction extends BaseAction, ActionResponse {
    type: 'respond'
    question_id: number
    question_type: 'nps' | 'csat' | 'fivestar'
    can_respond: boolean
    label?: string
}

export interface ActionResponse {
    id: number
    score: number
    created: number // unix timestamp
    author: string
    response?: string
    mentions?: TeamMember[]
    additionalComment?: string
}

export interface GraphData {
    labels: Array<string>
    nps: Array<string>
    totalResponded: Array<string>
    hoverDate: Array<string>
    period: string
    target: string
}

export interface Scorecard {
    id: number
    field: string // e.g. 'scorecard1_c'
    name: string // e.g. 'Personal Trainer'
    topics: ScorecardTopic[]
    responseCount: number
    isScorecard: boolean
}

export interface ScorecardTopic {
    id: number
    name: string // e.g. Knowledge
    label: string // e.g. Great Knowledge & Advice
    selectedPeriodScore: number
    changeSinceLastPeriod: number
}

export interface InstalledApp {
    key: string
    label: string
    svgIcon?: string
    faIcon?: string
    extraFieldType?: string
}

export interface Cases {
    all: number
    overdue: number
    open: number
    closed: number
    moderation?: number
}

export interface SendMethod {
    key: PraiseActionSendMethodKey
    label: string
    faIcon?: IconDefinition
    svgIcon?: boolean
    toolTipMsg?: string
    extraFieldType?: string
    data?: any
}

export interface TeamMember {
    name: string
    email?: string
}

interface FocusArea {
    name: string
    percentage: number
    type?: string
}

export interface FocusAreaData {
    currentFocusArea?: FocusArea
    recommendedFocusAreas?: FocusArea[]
    focusAreas: FocusAreaGroup
}

export interface FocusAreaGroup {
    [type: string]: FocusArea[]
}

export interface FocusAreaPayload {
    name: string
    type: string
    timePeriod: string
    timePeriodValue: string
    goalScore: string
    actions: string[]
}
